{
  "items": [
    {
      "fileName": "GENERIC-FamilyHome-01.mp4",
      "description": "The video shows four people, one man, one woman, and two girls, playing indoors in a living room. The woman is an adult female with fair skin and long, dark brown wavy hair, wearing a top, a pink, dusty rose colored jacket or shirt, laughing broadly with her mouth open, showing white teeth, giving an energetic, joyful, playful visible expression, while pushing a cardboard box. The man is an adult male with fair skin and short dark hair, wearing a top, a white, cream colored sweater, along with tan pants, laughing and smiling broadly, also pushing a cardboard box, giving an energetic, joyful, playful visible expression. The two girls, both young children with fair skin and light brown hair, are seated inside open cardboard boxes, with their arms raised upward, laughing and shouting with open mouths, giving excited, joyful, playful visible expressions. One girl is wearing a tan, brown colored sweater, and the other girl is wearing a pink top. The setting is an indoor living room environment, showing white paneled walls, a gray sofa, tall windows with tan, beige colored curtains, a wood cabinet or console table, a small potted plant, and additional cardboard boxes stacked on the floor. The lighting is bright and natural, consistent with daylight coming through the tall windows, evenly illuminating the family. The color palette is warm and bright, dominated by white, tan, pink, and gray tones, with brown accents from the cardboard boxes and wood furniture. The composition is a medium wide shot, full body framing, with the family positioned across the frame in dynamic motion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a bright, energetic look and a moderate depth of field.",
      "keyElements": [
        "cardboard boxes",
        "walls",
        "sofa",
        "windows",
        "curtains",
        "cabinet",
        "console table",
        "potted plant",
        "jacket color",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "energetic",
        "joyful",
        "playful",
        "excited",
        "candid",
        "action",
        "wide shot",
        "full body",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "warm tone",
        "family",
        "lifestyle",
        "moving",
        "man",
        "woman",
        "girls",
        "children",
        "father",
        "mother",
        "pink",
        "white",
        "tan",
        "cardboard box",
        "boxes",
        "sofa",
        "windows",
        "curtains",
        "plant",
        "console table"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-02.mp4",
      "description": "The video shows two people, one man and one woman, an elderly couple, sitting together indoors on a sofa reviewing documents. The man is an elderly adult male with a tan skin tone, short gray hair, and a gray beard and mustache, wearing eyeglasses, dark rimmed eyeglasses, and a top, a blue, denim blue button up shirt, holding a pen and a sheet of white paper, laughing broadly with his mouth open, showing white teeth, giving a joyful, warm, happy visible expression. The woman is an elderly adult female with a tan skin tone and short, gray, silver hair, wearing a top, a cream, beige colored blouse, along with a gold watch and a necklace, resting one hand on the man's shoulder, laughing broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression. The setting is an indoor living room environment, showing a light gray sofa, a teal, green patterned throw pillow, a white table in front of them holding an open notebook, papers, and a laptop computer, along with a black staircase with wood steps and floor to ceiling windows in the background showing green trees and foliage outside. The lighting is bright and natural, consistent with daylight coming through the large windows, evenly illuminating the couple. The color palette is warm and bright, dominated by blue, cream, gray, and green tones. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or financial planning style stock video with a bright, airy look and a shallow depth of field, keeping the staircase and windows background softly blurred.",
      "keyElements": [
        "sofa",
        "throw pillow",
        "table",
        "notebook",
        "papers",
        "laptop",
        "staircase",
        "windows",
        "trees",
        "foliage",
        "shirt color",
        "blouse color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "warm tone",
        "airy",
        "family",
        "lifestyle",
        "elderly",
        "senior",
        "couple",
        "man",
        "woman",
        "gray hair",
        "silver hair",
        "beard",
        "eyeglasses",
        "glasses",
        "blue",
        "cream",
        "sofa",
        "laptop",
        "papers",
        "staircase",
        "windows",
        "financial",
        "documents"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-03.mp4",
      "description": "The video shows one girl, a young child with a fair skin tone and dark black hair cut in a bob with straight bangs. The girl is wearing a top, a white sleeveless shirt or dress with a colorful, multicolored pattern including blue, pink, and orange sections, along with a thin necklace, holding a marker, a gray and black colored marker pen, and looking downward with a focused, calm, concentrated visible expression while writing or tracing letters. The setting is an indoor home environment, showing a gray, tufted leather sofa in the background, along with a pink, polka dot patterned blanket or piece of clothing draped over the sofa. In front of the girl is a colorful workbook or activity book with the alphabet, showing large letters such as A, B, C, D, E, and other letters in colorful squares of yellow, orange, purple, green, blue, and pink, along with a yellow toy visible on the left side of the frame and additional markers on the table. The lighting is soft and neutral, consistent with indoor ambient lighting, evenly illuminating the girl's face and the workbook. The color palette is bright and colorful, dominated by yellow, orange, purple, green, blue, and pink tones from the workbook, with gray from the sofa. The composition is a close up, closeup, downward angle framing, with the girl positioned in the upper portion of the frame and the workbook filling the lower portion. The visual style is photographic, realistic, and resembles an educational or lifestyle style stock video with a moderate depth of field.",
      "keyElements": [
        "sofa",
        "blanket",
        "workbook",
        "alphabet letters",
        "marker",
        "toy",
        "lighting"
      ],
      "attributes": [
        "calm",
        "focused",
        "concentrated",
        "candid",
        "close up",
        "closeup",
        "moderate depth of field",
        "soft lighting",
        "colorful",
        "bright",
        "educational",
        "learning",
        "lifestyle",
        "girl",
        "child",
        "bangs",
        "dark hair",
        "marker",
        "workbook",
        "alphabet",
        "letters",
        "yellow",
        "orange",
        "purple",
        "green",
        "blue",
        "pink",
        "sofa",
        "polka dot",
        "toy",
        "activity book"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-04.mp4",
      "description": "The video shows four people, one man, one woman, and two children, a boy and a girl, sitting closely together indoors on a sofa. The man is an adult male with a tan skin tone and dark, curly hair, along with a beard, smiling gently with a warm, calm visible expression. The woman is an adult female with a tan skin tone and dark, curly hair pulled back, smiling broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression. The boy and girl, both young children with tan skin tones and dark curly hair, are nestled between the two adults, with soft, content, calm visible expressions, looking off to the side. The setting is an indoor living room environment, showing a bright window with wood framing in the background, allowing a strong backlight to filter through and create a soft, hazy glow around the family. The lighting is bright and warm, consistent with strong backlight sunlight, creating lens flare and a glowing halo effect around the family's hair and shoulders. The color palette is warm and soft, dominated by light green, tan, and warm skin tones, with a hazy white glow from the window light. The composition is a medium close up, closeup, upper body framing, with the family positioned closely together toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field and soft, warm backlighting.",
      "keyElements": [
        "window",
        "wood framing",
        "backlight",
        "lens flare",
        "lighting"
      ],
      "attributes": [
        "warm",
        "calm",
        "joyful",
        "happy",
        "content",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "backlight",
        "lens flare",
        "hazy",
        "warm tone",
        "soft light",
        "family",
        "lifestyle",
        "man",
        "woman",
        "boy",
        "girl",
        "children",
        "curly hair",
        "beard",
        "window",
        "green"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-05.mp4",
      "description": "The video shows two people, one man and one boy, sitting together indoors on a sofa watching television. The man is an adult male with a dark brown skin tone and short dark hair, along with a light beard, wearing a top, a plaid, checkered patterned button up shirt in brown, white, and black tones, holding a football, a brown football with white stripes, close to his chest, smiling broadly with his mouth open, giving an excited, joyful, energetic visible expression. The boy is a young child with a dark brown skin tone and short dark hair, wearing a top, a blue t-shirt, with his hands raised and fingers spread, giving an excited, animated, joyful visible expression, looking upward and off to the side. The setting is an indoor living room environment, blurred softly out of focus behind the pair, showing a brown leather sofa, a red throw pillow, tall windows with gray curtains, a hanging chandelier, and an open doorway leading to another room. In the foreground is a white bowl containing popcorn. The lighting is bright and natural, consistent with daylight coming through the windows, evenly illuminating the pair. The color palette is warm and neutral, dominated by brown, blue, white, and gray tones, with a red accent from the throw pillow. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field, keeping the living room background softly blurred.",
      "keyElements": [
        "sofa",
        "throw pillow",
        "windows",
        "curtains",
        "chandelier",
        "doorway",
        "popcorn bowl",
        "football",
        "shirt pattern",
        "lighting"
      ],
      "attributes": [
        "excited",
        "joyful",
        "energetic",
        "animated",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "warm tone",
        "family",
        "lifestyle",
        "man",
        "boy",
        "father",
        "son",
        "beard",
        "plaid",
        "checkered",
        "shirt",
        "football",
        "popcorn",
        "sofa",
        "pillow",
        "windows",
        "curtains",
        "chandelier",
        "blue"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-06.mp4",
      "description": "The video shows two people, one woman and one man, positioned closely together indoors. The woman is a young adult female of Asian descent with a fair skin tone and dark black hair with straight bangs, smiling broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression, looking slightly downward and off to the side. The man is an adult male of Asian descent with a tan skin tone and short dark hair, along with light facial hair, positioned behind the woman, smiling with his mouth open, giving a joyful, warm, engaged visible expression, with one hand raised and fingers extended in a pointing or gesturing motion near a dark colored object, possibly a phone or tablet, in the lower right of the frame. The setting is an indoor home environment with a plain, light colored, blurred background, softly out of focus, giving minimal additional visual context. The lighting is soft, bright, and neutral, consistent with even indoor lighting, illuminating both people's faces without harsh shadows. The color palette is neutral and warm, dominated by white, tan, and warm skin tones. The composition is an extreme close up, closeup, tight framing, with both faces positioned in the upper left portion of the frame and a hand and dark object extending into the lower right portion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field.",
      "keyElements": ["background", "phone", "tablet", "lighting"],
      "attributes": [
        "joyful",
        "warm",
        "happy",
        "engaged",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "neutral tone",
        "family",
        "lifestyle",
        "woman",
        "man",
        "bangs",
        "dark hair",
        "gesturing",
        "pointing",
        "phone",
        "tablet",
        "indoor"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-07.mp4",
      "description": "The video shows three people, one man, one woman, and one toddler, playing together indoors on a rug, filmed from a direct overhead angle. The woman is an adult female with a tan skin tone and long, dark brown hair, wearing a top, a yellow, mustard colored sweater, laughing with an open mouth, giving a joyful, warm, playful visible expression, while holding the toddler. The man is an adult male with a tan skin tone and short, dark curly hair, wearing a top, a gray, green colored shirt, smiling broadly, giving a joyful, warm, playful visible expression. The toddler is a young child with a fair skin tone and short dark hair, wearing a top, a striped, blue and white striped shirt, laughing broadly with an open mouth, giving an excited, joyful, playful visible expression, with bare feet visible. The setting is an indoor living room environment, viewed from above, showing a dark gray woven round rug, a red throw pillow, a wood plank floor, and scattered children's toys including a colorful wooden shape sorter and small toy blocks in orange, blue, pink, and yellow tones. The lighting is warm and soft, consistent with dim ambient indoor lighting, creating a cozy atmosphere. The color palette is warm and colorful, dominated by yellow, gray, blue, and red tones, with colorful accents from the scattered toys. The composition is an overhead, top down shot, full body framing, with all three people positioned diagonally across the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a cozy, warm look and a moderate depth of field.",
      "keyElements": [
        "rug",
        "throw pillow",
        "wood floor",
        "toys",
        "shape sorter",
        "blocks",
        "sweater color",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "playful",
        "excited",
        "candid",
        "action",
        "overhead shot",
        "top down",
        "full body",
        "moderate depth of field",
        "warm lighting",
        "cozy",
        "dim lighting",
        "colorful",
        "family",
        "lifestyle",
        "man",
        "woman",
        "toddler",
        "child",
        "yellow",
        "mustard",
        "gray",
        "green",
        "striped shirt",
        "rug",
        "toys",
        "blocks",
        "shape sorter",
        "pillow"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-08.mp4",
      "description": "The video shows three people, one man and two boys, sitting together indoors on a sofa looking at a tablet computer. The man is an adult male with a dark brown skin tone and a bald or shaved head, wearing a top, a blue, teal colored polo shirt, smiling broadly, giving a joyful, warm, engaged visible expression, holding a tablet, a gray, dark colored tablet computer. The two boys, both young children with dark brown skin tones and curly dark hair, are seated on either side of the man, one wearing a striped, gray and white striped shirt with a soft, content, calm visible expression, and the other wearing a light green, striped shirt with a focused, curious, calm visible expression, both looking toward the tablet screen. The setting is an indoor living room and kitchen environment, showing a gray sofa, an olive green throw pillow and a tan, orange throw pillow, wood open shelving displaying dishes and small decorative objects, a dark arched cabinet with glass doors, and kitchen utensils in a holder on the counter. The lighting is soft, bright, and natural, consistent with even indoor lighting, evenly illuminating the family without harsh shadows. The color palette is warm and neutral, dominated by blue, tan, wood brown, and gray tones, with green accents from the throw pillow and shirt. The composition is a medium close up, closeup, upper body framing, with all three people positioned together toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field, keeping the kitchen background softly blurred.",
      "keyElements": [
        "sofa",
        "throw pillow",
        "shelving",
        "dishes",
        "cabinet",
        "kitchen utensils",
        "tablet",
        "shirt pattern",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "engaged",
        "content",
        "calm",
        "curious",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "family",
        "lifestyle",
        "man",
        "boys",
        "children",
        "father",
        "sons",
        "bald",
        "blue",
        "polo shirt",
        "tablet",
        "sofa",
        "pillow",
        "shelving",
        "cabinet",
        "kitchen",
        "striped shirt"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-09.mp4",
      "description": "The video shows four people, one man, one woman, and two girls, playing together indoors on a sofa. The man is an adult male with a fair skin tone and short dark hair, wearing a top, a white, cream colored sweater, laughing broadly, giving a joyful, warm, playful visible expression, while tickling or holding one girl. The woman is an adult female with a fair skin tone and long, dark brown wavy hair, wearing a top, a pink, mauve colored shirt, laughing with her mouth wide open, giving an excited, joyful, playful visible expression, while holding the other girl. Both girls are young children with fair skin tones and long light brown hair, wearing denim jeans, one wearing a tan, brown sweater and the other wearing a pink top, both laughing and smiling broadly, giving excited, joyful, playful visible expressions, with bare feet visible. The setting is an indoor living room environment, showing a light gray sofa, white paneled walls, a wood console table, tall windows with tan, beige curtains, and a small potted plant on the windowsill. The lighting is bright and natural, consistent with daylight coming through the windows, evenly illuminating the family. The color palette is bright and warm, dominated by white, tan, pink, and denim blue tones. The composition is a medium wide shot, full body framing, with the family positioned across the sofa in dynamic motion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a bright, energetic look and a moderate depth of field.",
      "keyElements": [
        "sofa",
        "walls",
        "console table",
        "windows",
        "curtains",
        "potted plant",
        "sweater color",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "playful",
        "excited",
        "candid",
        "action",
        "wide shot",
        "full body",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "warm tone",
        "family",
        "lifestyle",
        "man",
        "woman",
        "girls",
        "children",
        "father",
        "mother",
        "tickling",
        "white",
        "pink",
        "tan",
        "denim",
        "sofa",
        "windows",
        "curtains",
        "console table",
        "plant"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-10.mp4",
      "description": "The video shows two people, one man and one woman, sitting closely together indoors on a sofa. The man is an adult male with a tan skin tone, short dark curly hair, and a full dark beard, wearing a top, a pink, coral colored button up collared shirt, smiling broadly with his mouth open, showing white teeth, giving a joyful, warm, affectionate visible expression, with one arm resting behind the woman. The woman is an adult female with a tan skin tone and long, dark brown hair, wearing a top, a white, cream colored knit sweater, along with a colorful, patterned headband in red, white, and blue tones, and gold stud earrings, laughing with her mouth open, giving a joyful, warm, happy visible expression. The setting is an indoor living room environment, blurred softly out of focus behind the couple, showing a green sofa, a wood bookshelf holding books, tall windows with sheer white curtains, and a framed picture on the wall. In the foreground is a dark colored laptop computer. The lighting is soft, bright, and natural, consistent with daylight coming through the windows, evenly illuminating the couple. The color palette is warm and neutral, dominated by pink, coral, white, green, and wood brown tones. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or couple style stock video with a shallow depth of field, keeping the background softly blurred.",
      "keyElements": [
        "sofa",
        "bookshelf",
        "books",
        "windows",
        "curtains",
        "framed picture",
        "laptop",
        "shirt color",
        "sweater color",
        "headband",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "affectionate",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "couple",
        "lifestyle",
        "man",
        "woman",
        "beard",
        "curly hair",
        "pink",
        "coral",
        "white",
        "headband",
        "earrings",
        "sofa",
        "green",
        "bookshelf",
        "windows",
        "curtains",
        "laptop"
      ]
    },
    {
      "fileName": "GENERIC-FamilyHome-11.mp4",
      "description": "The video shows two people, one man and one woman, sitting together on the floor indoors, petting a dog. The man is an adult male with a fair skin tone and short dark hair, along with a beard, wearing a top, an orange, tan colored cardigan or sweater, smiling broadly, giving a warm, joyful, affectionate visible expression, while petting the dog. The woman is an adult female with a fair skin tone and dark hair pulled back, wearing a top, a white, cream colored sweater, smiling gently, giving a warm, content, affectionate visible expression, also petting the dog. The dog is a large animal with a dark brown, chocolate colored coat, standing on the floor between the two people. The setting is an indoor living room environment, showing a light gray woven rug on a wood plank floor, a green velvet sofa with a white throw blanket, a wood coffee table holding a plate with red tomatoes, a tall floor lamp with a yellow, mustard colored lampshade, floor to ceiling windows showing green trees outside, and a wood bookshelf on the right side of the frame. The lighting is warm and soft, consistent with natural daylight filtering through the windows combined with warm lamp light, creating a cozy, glowing atmosphere. The color palette is warm and rich, dominated by green, tan, brown, and yellow tones, with red accents from the tomatoes. The composition is a wide shot, full body framing, with both people and the dog positioned toward the center left of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a warm, cozy look and a moderate depth of field.",
      "keyElements": [
        "rug",
        "wood floor",
        "sofa",
        "throw blanket",
        "coffee table",
        "tomatoes",
        "floor lamp",
        "windows",
        "trees",
        "bookshelf",
        "cardigan color",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "affectionate",
        "content",
        "candid",
        "wide shot",
        "full body",
        "moderate depth of field",
        "warm lighting",
        "cozy",
        "natural light",
        "warm tone",
        "lifestyle",
        "pet",
        "couple",
        "man",
        "woman",
        "dog",
        "brown dog",
        "beard",
        "orange",
        "tan",
        "white",
        "green sofa",
        "rug",
        "lamp",
        "coffee table",
        "tomatoes",
        "windows",
        "trees",
        "bookshelf"
      ]
    }
  ]
}
